import classnames from 'classnames/bind'
import PropTypes from 'prop-types'
import React from 'react'
import styles from './container.module.scss'

const cx = classnames.bind(styles)

const Container = ({ children, className, fluid, noGap }) => {
  if (!children) {
    return null
  }

  return (
    <div
      className={cx(className, {
        containerFluid: fluid,
        containerFixed: !fluid,
        hasGap: !noGap
      })}
    >
      {children}
    </div>
  )
}

Container.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string,
  fluid: PropTypes.bool,
  noGap: PropTypes.bool
}

Container.defaultProps = {
  children: null,
  className: null,
  fluid: false,
  noGap: false
}

export default Container
